module.exports = __webpack_public_path__ + "img/promo-hover.4073a45b.svg";